import styled from "@emotion/styled";
import * as React from "react";

const SvgWrapper = styled.div(({theme, active}) => ({
  transition: "color 0.3s ease-in-out",
  ":hover": {
    "svg path": {
      stroke: active && theme?.colors?.primaryBlack,
    },
  },
}));

const ArrowLeft = ({color, width, height, active}) => (
  <SvgWrapper active={active}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 14"
      width={width}
      height={height}
      role="img"
      aria-label={"left arrow"}
    >
      <path
        d="M7 13L1 7L7 1"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgWrapper>
);

export default ArrowLeft;
